
// src/utils/tenant.js
export function getOrg() {
  const url = new URL(window.location.href);
  const qsOrg = url.searchParams.get('org') || url.searchParams.get('orgId') || '';
  const qsOrgName = url.searchParams.get('orgName') || '';
  const qsStore = url.searchParams.get('store') || url.searchParams.get('storeId') || '';
  const qsStoreName = url.searchParams.get('storeName') || '';

  let installParams = {};
  try {
    installParams = JSON.parse(localStorage.getItem('installParams') || '{}') || {};
  } catch {
    installParams = {};
  }

  const resolvedOrgId = qsOrg || installParams.orgId || '';
  const resolvedOrgName = qsOrgName || installParams.orgName || '';
  const resolvedStoreId = qsStore || installParams.storeId || '';
  const resolvedStoreName = qsStoreName || installParams.storeName || '';

  // hydrate from query / persisted install params once
  if (resolvedOrgId) localStorage.setItem('orgId', resolvedOrgId);
  if (resolvedOrgName) localStorage.setItem('orgName', resolvedOrgName);
  if (resolvedStoreId) localStorage.setItem('storeId', resolvedStoreId);
  if (resolvedStoreName) localStorage.setItem('storeName', resolvedStoreName);

  const orgId = localStorage.getItem('orgId') || resolvedOrgId || '';
  const orgName = localStorage.getItem('orgName') || resolvedOrgName || '';
  const storeId = localStorage.getItem('storeId') || resolvedStoreId || '';
  const storeName = localStorage.getItem('storeName') || resolvedStoreName || '';
  const deviceUid = localStorage.getItem('deviceUid') || '';

  return { orgId, orgName, storeId, storeName, deviceUid };
}

import { collection, doc } from 'firebase/firestore';
export function orgCol(db, subPath, orgIdOverride) {
  const { orgId } = getOrg();
  const oid = orgIdOverride || orgId;
  if (!oid) return collection(db, subPath); // fallback for legacy
  return collection(db, 'orgs', oid, subPath);
}
export function orgDoc(db, subPath, id, orgIdOverride) {
  const { orgId } = getOrg();
  const oid = orgIdOverride || orgId;
  if (!oid) return doc(db, subPath, id); // legacy
  return doc(db, 'orgs', oid, subPath, id);
}
